/**
 * Returns the uppercase initial of a string.
 *
 * @param value - The input string (e.g., a name)
 */
const getInitial = (value: string) => value.trim().charAt(0).toUpperCase();

/**
 * Returns the initials for a user given first and last name.
 *
 * @param firstName - The user's first name
 * @param lastName - The user's last name
 * @returns The initials (e.g., 'JD' for John Doe)
 */
export const getUserInitials = (firstName: string, lastName: string) => {
  const first = getInitial(firstName);
  const last = getInitial(lastName);
  return `${first}${last}`;
};
